import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { formConstant } from '../../../../../../config';
import { NotificationService } from '../../../../../core/services/notification.service';
import { UserService } from '../../../../../core/services/user.service';
import { ShipmentPriceService } from '../../../services/shipment-price.service';

@Component({
    selector: 'eci-service',
    templateUrl: './service.component.html',
    styleUrls: ['./service.component.scss'],
})
export class ServiceComponent implements OnInit {
    public showLoader = false;
    public createMode: boolean = false;
    public isSubService: boolean = false;
    public serviceId: number;
    public service: any;
    public form: FormGroup;
    public title = 'Service';
    public nameMaxLength = formConstant.textFieldMaxLength120;

    constructor(private userSvc: UserService,
                private notify: NotificationService,
                public dialogRef: MatDialogRef<ServiceComponent>,
                private shipmentPriceSvc: ShipmentPriceService) {
    }

    ngOnInit(): void {
        this.form = this.initializeForm();
    }

    private initializeForm(): FormGroup {
        return new FormGroup({
            subServiceId: new FormControl({disabled: true, value: this.service?.subServiceId || ''}),
            serviceId: new FormControl({disabled: true, value: this.service?.serviceId}),
            name: new FormControl(
                this.service?.name || '',
                [
                    Validators.required,
                    Validators.maxLength(this.nameMaxLength),
                ]),
            createdBy: new FormControl({disabled: true, value: this.service?.createdBy || ''}),
            vendors: new FormControl(''),
        });

    }

    public get isAdmin(): boolean {
        return this.userSvc.isAdmin;
    }

    public onNoClick(): void {
        this.dialogRef.close();

    }

    public onSubmit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            this.notify.showError('Not all fields are filled');
            return;
        }
        const data = this.form.value;
        if (this.isSubService) {
            data.serviceId = this.serviceId;
        }
        if (this.createMode) {
            this.save(data);
        } else {
            this.update(this.service.id, data);
        }
    }

    private save(service): void {
        if (!service) {
            return;
        }
        this.showLoader = true;
        service.createdBy = this.userSvc.user.email;

        this.shipmentPriceSvc.create<any>(this.isSubService ? 'sub-service' : 'service', service)
            .subscribe((v) => {
                this.notify.showSuccessMessage(`${this.isSubService ? 'SubService' : 'Service'} ${v.name} was created successfully`);
                this.dialogRef.close();
            }, (err) => {
                this.notify.showError(err.error.message);
                this.showLoader = false;
            });
    }

    private update<T>(id: number, service: T): void {
        if (!service) {
            return;
        }
        this.showLoader = true;
        this.shipmentPriceSvc.update<T>(this.isSubService ? 'sub-service' : 'service', id, service)
            .subscribe((v) => {
                this.notify.showSuccessMessage(`Update successfully`);
                this.dialogRef.close();
            }, (err) => {
                this.notify.showError(err.error.message);
                this.showLoader = false;
            });
    }
}
